import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import Seat from './Seat/Seat';

import styles from './Seats.module.css';

import planeShortHaulOutbound from './img/shortHaulPlane1_big.jpg';
import embraer from './img/embraer.jpg';
import sevenFourSeven from './img/747_clean.svg';
import planeLongHaulReturn from './img/747_clean.svg';

const cx = classNames.bind(styles);


// each plane has its own 

const plane1 = {
  alignmentStyles: {
    transform: 'translate(-763px, -412px)',
  },
  planeImageWidth: {
    width: '1890px',
  },
  zoomOutScaleStyles: {
    transform: 'translate(-520px, -830px) scale(0.18)',
    transition: 'all 1s',
    transitionTimingFunction: 'ease-in-out'
  }, 
  zoomInScaleStyles: {
    transform: 'translate(0, 0) scale(1)',
  },
  image: planeShortHaulOutbound,
  seats: [
    {value: "1A", left: 126, top: 187},
    {value: "1B", left: 196, top: 187},
    {value: "2A", left: 126, top: 293},
    {value: "2B", left: 196, top: 293},
    {value: "3A", left: 126, top: 370},
    {value: "3B", left: 196, top: 479},
  ]
}

const plane2 = {
  alignmentStyles: {
    transform: 'translate(-757px, -992px)',
  },
  planeImageWidth: {
    width: '1890px',
  },
  zoomOutScaleStyles: {
    transform: 'translate(-557px, -1080px) scale(0.13)',
  }, 
  zoomInScaleStyles: {
    transform: 'translate(297px, 320px) scale(1.4)',
  },
  image: embraer,
  seats: []
}

// plane 3 settings moved to render method as they require some dyanimc properties
const plane3 = {
  image: sevenFourSeven,
  seats: []
}

const seatLetters = "0ABCDEFGHIJKLMNO";



const seatGenerator = (planeObj, firstRow, firstColumn, rowCount, columnCount, startTop, startLeft, _rowSpacing, _columnSpacing) => {
  const rowSpacing = _rowSpacing || 67
  const columnSpacing = _columnSpacing || 48
  for (let row = 0; row < rowCount; row++) {
    for (let column = 0; column < columnCount; column++) {
      const value = `${row+firstRow}${seatLetters[column+firstColumn]}`
      const seat = {
        value: value,
        left: (startLeft + (columnSpacing * column)),
        top: (startTop + (rowSpacing * row)),
        scale: planeObj !== plane3 ? 0.6 : null,
        // randomly disable some seats - but make sure not to disable the auto selected one
        disabled: (Math.random()) > 0.7,
        rotated: planeObj === plane3,
      };
      
      planeObj.seats.push(seat);
    }
  }
}



// generate seats for plane 3
// first class
seatGenerator(plane3, 1, 1, 6, 2, 523, -37, 107, 55 );
seatGenerator(plane3, 1, 4, 6, 3, 430, 98, 107, 55 );
seatGenerator(plane3, 1, 7, 6, 2, 523, 288, 107, 55 );

//economy bank 1
seatGenerator(plane3, 8, 1, 17, 3, 1498, -62 );
seatGenerator(plane3, 7, 4, 18, 3, 1440, 104, 65.5 );
seatGenerator(plane3, 8, 7, 17, 3, 1498, 270 );
//economy bank 2
seatGenerator(plane3, 25, 1, 13, 3, 2767, -62 );
seatGenerator(plane3, 25, 4, 13, 3, 2755, 104, 65.5 );
seatGenerator(plane3, 25, 7, 13, 3, 2767, 270 );



// generate seats for plane 2
// planeObj, firstRow, firstColumn, rowCount, columnCount, startTop, startLeft, _rowSpacing, _columnSpacing
seatGenerator(plane2, 1, 1, 11, 1, -492, 106, 51.5 );
seatGenerator(plane2, 12, 1, 7, 1, 113, 106, 51.5 );

seatGenerator(plane2, 3, 2, 9, 2, -389, 182, 51.5, 34 );
seatGenerator(plane2, 12, 2, 7, 2, 113, 182, 51.5, 34 );




class Seats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSeatValue: this.props.selected,
      isExpanded: false,
      isLongHaul: false,
      isLoadingSeats: this.props.zoomed,
      center: 0,
      isIphone8: window.innerHeight < 700
    };


    this.onSelectSeat = this.onSelectSeat.bind(this);
    // move this to a Dropdown component
    this.onDropdownToggle = this.onDropdownToggle.bind(this);
    this.confirmSeat = this.confirmSeat.bind(this);
    this.backClicked = this.backClicked.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.hideSeats = this.hideSeats.bind(this);
    
    if (this.props.zoomed) {
      this.showSeats()
    }

    // additionally, send value to highlight seat
    if (this.props.selected) {
      this.state.selectedSeatValue = this.props.selected;
    }
  }


  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // set the initial state.center property
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    let yOffset = this.props.direction === 'outbound' ? -345 : 100;
    if(this.state.isIphone8) yOffset += ( this.props.direction === 'outbound' ? 155 : 135 );
    const center = (-960 - ( window.innerHeight / 2) - yOffset ) + window.scrollY;
    this.setState({
      center
    })
  }


  componentWillReceiveProps(newProps) {
    if (newProps.match && this.props.direction !== newProps.direction) {
      // directions have changed
      // this.setState({
      //   selectedSeatValue: null,
      // });
      // window.scrollTo(0, 0); // scroll back to the top of the page
    }
    if(!this.state.isLoadingSeats && newProps.zoomed){
      this.showSeats();
    }
  }

  showSeats = () => {

    this.setState({
      isLoadingSeats : true
    });
    
    this.refs.planePositionWrapper.style.width = 'initial';
    this.refs.planePositionWrapper.style.height = 'initial';

    const onTransitionFinished = (e) => {
      console.log('transition in finished');
      setTimeout(() => {
        if(this.props.isLongHaul) document.body.style.overflowY = "hidden";
        this.refs.planePositionWrapper.style.width = 'auto';
        // this.refs.planePositionWrapper.style.height = '200vh';
      }, 500);
      this.refs.planePositionWrapper.removeEventListener("webkitTransitionEnd",onTransitionFinished);
    }
    
    // fixes a bug with overflow scrolling after a transition
    this.refs.planePositionWrapper.addEventListener("webkitTransitionEnd", onTransitionFinished, false);

 
  };

  hideSeats = () => {
    this.setState({ isLoadingSeats : false });
    this.refs.planePositionWrapper.removeEventListener("webkitTransitionEnd",() => null);


    const onTransitionFinished = (e) => {
      console.log('transition out finished');
      document.body.style.overflowY = "initial";
      this.refs.planePositionWrapper.removeEventListener("webkitTransitionEnd",onTransitionFinished);
    }

    this.refs.planePositionWrapper.addEventListener("webkitTransitionEnd", onTransitionFinished, false);
  }

  // move this to a Dropdown component
  onDropdownToggle(e) {
    const expanded = this.state.isExpanded;
    this.setState({ isExpanded: !expanded });
  }

  onSelectSeat(e) {
    const value = e.currentTarget.getAttribute('data-value');
    const selectedSeatValue = this.state.selectedSeatValue === value ? null : value;

    this.setState({
      selectedSeatValue,
    });


  };

  confirmSeat(e) {
    e.preventDefault();

    if (this.props.direction === 'outbound') {
      this.props.setOutboundSeat(this.state.selectedSeatValue);
    } else {
      this.props.setReturnSeat(this.state.selectedSeatValue);
    }

    this.hideSeats();
    if(this.props.onClose) {
      this.props.onClose();
    };

    this.props.onChange(this.props.direction, this.state.selectedSeatValue);

  }

  backClicked(e) {
    // e.preventDefault();
    this.hideSeats();
    if(this.props.onClose) {
      this.props.onClose();
    };

    
  }

  returnAirline() {
    if(!this.props.isLongHaul){
      if(this.props.direction === 'outbound'){
        return 'surf air'
      } else {
        return 'jet suite x'
      }
    } else {
      if(this.props.direction === 'outbound'){
        return 'virgin'
      } else {
        return 'united'
      }
    }
  }

  render() {

    const { id, direction, isLongHaul } = this.props;
    const isOutbound = direction === 'outbound';
    // const center = this.refs.planeScaleWrapper.parentElement.getBoundingClientRect().top + this.refs.planeScaleWrapper.getBoundingClientRect().top;
    Object.assign(plane3,{
      seatOffset: {
        // top: '-1250px',
        // left: '769px',
        transform: 'scale(0.36) translate(770px, 390px)',
      },
      planeImageWidth: {
        width: '1890px',
        transform: 'scale(1) translateY(580px)',
      },
      zoomOutScaleStyles: {
        transform: 'scale(0.16) rotate(0deg) translateY(-500px)',
        transition: 'all 1s',
        transitionTimingFunction: 'ease-in-out'
      },
      zoomInScaleStyles: {
        transform: `scale(${this.state.isIphone8 ? 2 : 2.55 }) rotate(-90deg)`,
        // height: '100%',
        transition: 'all 1s',
        transitionDelay: '1s',
        transitionTimingFunction: 'ease-in-out'
      },
      zoomOutPositionStyles: {
        transform: 'translate3d(-34%, -1000px, 0px)',
        width: 'auto',
        transition: 'all 1s',
        transitionTimingFunction: 'ease-in-out'
      },
      zoomInPositionStyles: {
        transform: `translate3d(-40%, ${this.state.center}px, 0)`,
        overflowX: 'scroll',
        overflowY: 'hidden',
        transition: 'all 1s',
        transitionTimingFunction: 'ease-in-out'
      },
    });



    const seatWrapperStyles = cx({
      seatPageWrapper: true,
      isShortHaul: !this.state.isLongHaul,
      isLongHaul: this.state.isLongHaul,
      horizontalScroll: this.state.isLoadingSeats
    });

    const footerStyles = cx({
      footer: true,
      open: this.state.isLoadingSeats,
    })

    const headerStyles = cx({
      header: true,
      open: this.state.isLoadingSeats,
    })

    let activePlane = plane1; // default to plane 1

    if(isLongHaul) {
      activePlane = plane3;
    } else {
      if(isOutbound) {
        activePlane = plane1;
      } else {
        activePlane = plane2;
      }
    }


    return (
      <div ref={`plane${this.props.flight}`} className={(this.state.isLoadingSeats ? styles.seatsLoaded : '')}>

        {/* <Link className={styles.button} to={`/`} onClick={this.showSeats}>Change Seats</Link> */}

        {this.props.isLongHaul ? <div ref={"header"} className={headerStyles}>
            <div onClick={this.backClicked} className={styles.back}>BACK</div>
            <div className={this.state.isExpanded ? styles.dropdown +' '+ styles.expanded : styles.dropdown }>
              <button onClick={this.onDropdownToggle}>Economy class <span>$1,239.00</span></button>
              <ul>
                <li>Premium Economy Class</li>
                <li>Business Class</li>
              </ul>
            </div>
          </div> : null }

        {/* <div className={seatWrapperStyles} style={{transform:`translate3d(-35%, ${!this.state.isLoadingSeats ? -1000 - this.state.scrollTop+'px' : '-79%' }, 1px`}}>   */}
        <div ref="planePositionWrapper" className={seatWrapperStyles} style={this.state.isLoadingSeats ? activePlane.zoomInPositionStyles : activePlane.zoomOutPositionStyles} >  
          
          <div ref="planeScaleWrapper" className={styles.seats} style={this.state.isLoadingSeats ? activePlane.zoomInScaleStyles : activePlane.zoomOutScaleStyles} >            
            <div className={styles.planeImage} style={activePlane.alignmentStyles}>
              <img src={activePlane.image} style={activePlane.planeImageWidth}  alt="" />
            </div>
          
            <div className={[styles.outbound, styles.seatWrapper].join(' ')} style={activePlane.seatOffset}>
              {activePlane.seats.map((seat, i) => {
                return <Seat
                  airline={this.returnAirline()}
                  value={seat.value}
                  key={i}
                  left={seat.left}
                  top={seat.top}
                  scale={seat.scale}
                  disabled={this.state.selectedSeatValue === seat.value ? false : seat.disabled}
                  rotated={seat.rotated}
                  onToggle={this.onSelectSeat}
                  selected={this.state.selectedSeatValue === seat.value } 
                />
              })}
            </div>
          </div>
        

          
        </div>

        <div className={footerStyles}>
            <h3 id="seat-selection">{this.state.selectedSeatValue ? `Seat ${this.state.selectedSeatValue}` : 'Select Your Seat'}</h3>
            { direction === 'outbound' ?
              <div>
                <p>OAK → SBA</p>
                <Link
                  to={`/flights/review`}
                  className={this.state.selectedSeatValue ? styles.isReady : null}
                  onClick={this.confirmSeat}>
                  Continue
                </Link>
              </div>
            :
              <div>
                <p>SBA → SJC</p>
                <Link
                  to={`/flights/review`}
                  className={this.state.selectedSeatValue ? styles.isReady : null}
                  onClick={this.confirmSeat}>
                  Continue
                </Link>
              </div>
            }
          </div>

      </div>
    );
  }
}

Seats.defaultProps = {
  direction: 'outbound',
  flight: 0,
}

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  outboundFlightData: main.outboundFlightData,
  returnFlightData: main.returnFlightData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setOutboundSeat: data =>
      dispatch({
        type: 'SET_OUTBOUND_SEAT',
        payload: data,
      }),
    setReturnSeat: data =>
      dispatch({
        type: 'SET_RETURN_SEAT',
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Seats);



// WEBPACK FOOTER //
// ./src/components/Seats/Seats.jsx